import styled from 'styled-components'

import CBanner from '../../components/Banner'
import CMarkdownText from '../../components/MarkdownText'
import CUnderlineTitle from '../../components/UnderlineTitle'
import breakpoints from '../../theme/breakpoints'
import ActionButton from '../../components/ActionButton'
import BoxedContent from '../../components/BoxedContent'

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  width: 100%;
`

export const Banner = styled(CBanner)``

export const Wrapper = styled(BoxedContent)`
  padding: 4rem 1.6rem;
`

export const Block = styled.div`
  margin-bottom: 4rem;
`

export const Actions = styled.div`
  display: flex;
  gap: 2.4rem;
`

export const UnderlineTitle = styled(CUnderlineTitle)`
  margin-bottom: 0.8rem;
`

export const Identity = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.6rem;

  ${breakpoints.up('tablet')} {
    flex-direction: row;
    gap: 4rem;
  }
`

export const MarkdownText = styled(CMarkdownText)`
  ${({ theme }) => theme.textStyles.text};
  font-size: 1.6rem;
  color: ${({ theme }) => theme.colors.nightRider};

  ${breakpoints.up('tablet')} {
    font-size: 1.8rem;
  }
`

export const Button = styled(ActionButton)`
  display: block;
  margin-bottom: 2.4rem;
  width: max-content;
`
